// Force US date/time formatting (MM/DD/YYYY, 12-hour clock) everywhere, regardless of device locale.
const LOCALE = "en-US";
const hasLocale = (l) => l !== undefined && !(Array.isArray(l) && l.length === 0);
const wrap = (name, fixTime) => {
  const orig = Date.prototype[name];
  Date.prototype[name] = function (locales, options) {
    const opts = { ...(options || {}) };
    if (fixTime && opts.hour12 === undefined && opts.hourCycle === undefined && (opts.hour !== undefined || opts.timeStyle !== undefined || name !== "toLocaleDateString")) opts.hour12 = true;
    return orig.call(this, hasLocale(locales) ? locales : LOCALE, opts);
  };
};
wrap("toLocaleDateString", false);
wrap("toLocaleTimeString", true);
wrap("toLocaleString", true);

export const usDate = (v) => {
  if (!v) return "—";
  if (typeof v === "string" && /^\d{4}-\d{2}-\d{2}$/.test(v)) return `${v.slice(5, 7)}/${v.slice(8, 10)}/${v.slice(0, 4)}`;
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? String(v) : d.toLocaleDateString(LOCALE, { month: "2-digit", day: "2-digit", year: "numeric" });
};
export const usTime = (v) => (v ? new Date(v).toLocaleTimeString(LOCALE, { hour: "numeric", minute: "2-digit", hour12: true }) : "—");
export const usDateTime = (v) => (v ? `${usDate(v)} ${usTime(v)}` : "—");
